export default "__VITE_ASSET__oNaAUAwo__"